"use client";

import { cn } from "@workspace/frontend-ui";
import type { FC } from "react";
import splitDuration from "./splitDuration";
import TimeBox from "./TimeBox";
import useIsHydrated from "./useIsHydrated";

type Props = {
  secondsLeft: number;
  className?: string;
};

// Client-only: the server and the browser read the clock a moment apart, so
// server-rendered digits never match the hydrating ones. Until hydration ends
// the boxes render invisible with placeholder digits, keeping their space.
const PromoBannerCountdown: FC<Props> = ({ secondsLeft, className }) => {
  const isHydrated = useIsHydrated();
  if (secondsLeft <= 0) return null;

  const { days, hours, minutes, seconds } = splitDuration(secondsLeft);

  return (
    <div
      className={cn(
        "flex gap-x-2 max-md:mt-2",
        !isHydrated && "invisible",
        className,
      )}
      aria-hidden={!isHydrated || undefined}
      data-testid="promo-banner-countdown"
    >
      <TimeBox n={days} type="day" hideValue={!isHydrated} />
      <TimeBox n={hours} type="hour" hideValue={!isHydrated} />
      <TimeBox n={minutes} type="min" hideValue={!isHydrated} />
      <TimeBox n={seconds} type="sec" hideValue={!isHydrated} />
    </div>
  );
};

export default PromoBannerCountdown;
